module.exports = __webpack_public_path__ + "static/img/3-2.bbd30ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3-2.png
// module id = c2ap
// module chunks = 1